module.exports = __webpack_public_path__ + "img/beyond-logo.d5299d14.jpg";